// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { PropsWithChildren } from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';

type Props = PropsWithChildren & {
  open: boolean;
  closeModal: () => void;
  action?: React.MouseEventHandler<HTMLButtonElement>;
  smWidth?: boolean;
  cancel?: () => void;
  actionButtonText?: string;
  stylesProps?: React.CSSProperties;
  disabled?: boolean;
  showCloseIcon?: boolean;
  zIndex?: never;
  classNames?: {
    overlay?: string;
    modal?: string;
    closeButton?: string;
    closeIcon?: string;
    animationIn?: string;
    animationOut?: string;
  };
};

export default ({
  open,
  closeModal,
  action,
  smWidth,
  cancel,
  actionButtonText,
  children,
  stylesProps,
  disabled,
  showCloseIcon = true,
  zIndex,
  classNames,
}: Props) => {
  const styles = smWidth
    ? { maxWidth: '800px', width: 'auto', fontSize: '18px' }
    : {};

  const eventFormStyles: React.CSSProperties = {};

  if (
    children &&
    children['props'] &&
    children['props'].typeOfChange === 'Event'
  )
    eventFormStyles.background = '#f7f7f7';

  return (
    <Modal
      open={open}
      showCloseIcon={showCloseIcon}
      styles={{
        modal: { ...stylesProps, ...styles, ...eventFormStyles },
        overlay: zIndex && {
          zIndex,
        },
      }}
      classNames={classNames}
      closeOnOverlayClick={!!action}
      onClose={closeModal}
      closeIcon={<i className='fas fa-times' />}
      center
    >
      {children}
      {action && (
        <button
          className='btn btn-primary pull-right'
          type='button'
          style={{ marginRight: '0px', minWidth: '70px' }}
          onClick={action}
          disabled={disabled}
        >
          {actionButtonText}
        </button>
      )}
      {cancel && (
        <button
          className='btn btn-def pull-right'
          style={{ marginRight: '25px', minWidth: '70px' }}
          type='button'
          onClick={cancel}
        >
          Cancel
        </button>
      )}
    </Modal>
  );
};
